"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

const IconStreaming = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = (0, _objectWithoutProperties2.default)(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/_react.default.createElement("title", null, title) : null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M20 6.25H4A2.75 2.75 0 001.25 9v11A2.75 2.75 0 004 22.75h16A2.75 2.75 0 0022.75 20V9A2.75 2.75 0 0020 6.25zM4 7.75h16c.69 0 1.25.56 1.25 1.25v11c0 .69-.56 1.25-1.25 1.25H4c-.69 0-1.25-.56-1.25-1.25V9c0-.69.56-1.25 1.25-1.25z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.47 1.47a.75.75 0 01.976-.073l.084.073L12 5.939l4.47-4.47a.75.75 0 01.976-.072l.084.073a.75.75 0 01.073.976l-.073.084-5 5a.75.75 0 01-.976.073l-.084-.073-5-5a.75.75 0 010-1.06z"
  }));
};

const ForwardRef = /*#__PURE__*/_react.default.forwardRef((props, ref) => /*#__PURE__*/_react.default.createElement(IconStreaming, (0, _extends2.default)({
  svgRef: ref
}, props)));

var _default = ForwardRef;
exports.default = _default;